const apiUrl = process.env.REACT_APP_API_URL;

const getSites = (token, cb) => {
    fetch(`${apiUrl}/stages`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(res => res.json())
        .then(res => {
            cb(res);
        });
};

export default getSites;
